
<div id="custom-tabs-component" class="flex flex-col justify-center items-center " *ngIf="fields">
    <div class="rounded-full backdrop-blur-xl bg-moving p-2 shadow-xl ">

        <div class="flex w-full gap-2  {{isMobile ? 'justify-start text-md' : 'justify-center  rounded-full text-xl '}}  items-center  element-container before:rounded-full {{isMobile ? 'before:invisible' :''}}" style="max-width: 80vw; overflow: auto; scrollbar-width: none">

            <div *ngFor="let tab of fields; let i = index" class="w-full"> <!-- aggiungi keypress -->

                <div [id]="tab.routerOutlet" tabindex="{{i}}"
                    (click)="selectElement(tab.routerOutlet);navigateToPage(tab.routerOutlet,tab.routerParams)"
                    class="w-full whitespace-nowrap  tab transition-all duration-300 cursor-pointer disabled:cursor-not-allowed rounded-full p-2 step-active hover:bg-primary-800/20 hover:text-white {{active == tab.routerOutlet ? isMobile ? 'bg-primary-500 selected': 'selected' : 'text-primary-500'}} ">
                    {{tab.title}}
                </div>

            </div>
        </div>
    </div>
</div>
